require('../../proto/javascript/netop_rc_base_pb')
require('../../proto/javascript/netop_rc_route_pb')
require('../../proto/javascript/netop_rc_tracing_pb')
require('../../proto/javascript/netop_rc_transport_pb')
require('../../proto/javascript/netop_rc_signaling_pb')
require('../../proto/javascript/netop_rc_portal_cm_pb')

import { createTransportMeta } from './metaCreators'

export class TransportMessageCreator {

  constructor () {
    this._createTransportMeta = createTransportMeta
  }

  create = (bodyBinary) => {
    const transportMessage = new proto.netop.rc.transport.Message()
    transportMessage.setNetopMessageType('netop.rc.transport.Message')
    transportMessage.setMeta(this._createTransportMeta())
    transportMessage.setBody(bodyBinary)
    const transportMessageBinary = transportMessage.serializeBinary()

    return transportMessageBinary
  }

}
